import type { FC } from "react";
import {CircularProgress, Stack, Typography} from "@mui/material";
import StartupImage1 from "assets/images/startup-image1.jpg";
import StartupImage2 from "assets/images/startup-image2.jpg";
import StartupImage3 from "assets/images/startup-image3.jpg";
import StartupImage4 from "assets/images/startup-image4.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {Box} from "@mui/system";
import {ReactComponent as LogoSVG} from "../../assets/images/logo.svg";
import React from "react";

interface StartupImageViewProps {
  imageIndex: number | null;
}

export const StartupImageView: FC<StartupImageViewProps> = ({ imageIndex }) => {
  return (
      <Stack
          flex={1}
          position="relative"
          sx={{ "& > img": { height: "100%", width: "100%", objectFit: "cover" } }}
      >
        {imageIndex !== null && (
            <LazyLoadImage
                src={
                  [
                    StartupImage1,
                    StartupImage2,
                    StartupImage3,
                    StartupImage4,
                  ][imageIndex]
                }
            />
        )}
        <Stack position="absolute" bottom={30} left={0} right={0}>
          <Box
              alignSelf={"center"}
              zIndex={2}
              sx={{ transform: "scale(2)", mb: 1 }}
          >
            <LogoSVG />
          </Box>
          <Typography
              color={"white"}
              fontFamily={"Inter"}
              fontWeight={500}
              fontSize={12}
              textAlign={"center"}
              sx={{ opacity: 0.5, mx: 9, mb: "2vh" }}
          >
            The biggest and most popular Iranian music streaming service.
          </Typography>
          <Box sx={{ position: 'relative', mx: 'auto', mt: 5 }}>
            <CircularProgress
                variant="determinate"
                sx={{
                  color: '#326F5F'
                }}
                size={20}
                thickness={4}
                value={100}
            />
            <CircularProgress
                variant="indeterminate"
                disableShrink
                sx={{
                  color: '#0c3e30',
                  animationDuration: '550ms',
                  position: 'absolute',
                  left: 0,
                }}
                size={20}
            />
          </Box>
        </Stack>
      </Stack>
  );
};
